"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAgreementTermsResponseAllOfToJSON = exports.GetAgreementTermsResponseAllOfFromJSONTyped = exports.GetAgreementTermsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetAgreementTermsResponseAllOfFromJSON(json) {
    return GetAgreementTermsResponseAllOfFromJSONTyped(json, false);
}
exports.GetAgreementTermsResponseAllOfFromJSON = GetAgreementTermsResponseAllOfFromJSON;
function GetAgreementTermsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'agreementTerms': (json['agreementTerms'].map(_1.AgreementTermFromJSON)),
    };
}
exports.GetAgreementTermsResponseAllOfFromJSONTyped = GetAgreementTermsResponseAllOfFromJSONTyped;
function GetAgreementTermsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'agreementTerms': (value.agreementTerms.map(_1.AgreementTermToJSON)),
    };
}
exports.GetAgreementTermsResponseAllOfToJSON = GetAgreementTermsResponseAllOfToJSON;
